// import { useState, Fragment } from "react";
// import "./styles.sass";
// import assets from "../../assets";
// import {
//   COMPETITIVE_EXAM_STATIC_DATA,
//   CATEGORY_LIST,
//   LANGUAGE_OPTIONS,
// } from "../../utils/constant";
// import useHandler from "./handler";
// import { Popup } from "../../neet-j2e/Pop-up";

// const CLASS_OPTIONS = [
//   "Class 1",
//   "Class 2",
//   "Class 3",
//   "Class 4",
//   "Class 5",
//   "Class 6",
//   "Class 7",
//   "Class 8",
//   "Class 9",
//   "Class 10",
//   "Class 11",
//   "Class 12",
// ];

// export const CompetitiveExam = () => {
//   const [isOpen, setIsOpen] = useState(false);
//   const [selectedCategory, setSelectedCategory] = useState(CATEGORY_LIST[0]);
//   const [viewMode, setViewMode] = useState("grid"); // "grid" or "list"

//   const [enrolledExams, setEnrolledExams] = useState([]);
//   const [showAccessPopup, setShowAccessPopup] = useState(false);
//   const [selectedExamForAccess, setSelectedExamForAccess] = useState(null);
//   const [accessData, setAccessData] = useState({
//     classGrade: "Class 8",
//     medium: "English",
//   });
//   const [activeDropdown, setActiveDropdown] = useState(null);
//   const [step, setStep] = useState("selection"); // 'selection', 'plans', 'payment'
//   const [billingCycle, setBillingCycle] = useState("Monthly");
//   const [selectedPlan, setSelectedPlan] = useState(null);
//   const [paymentMethod, setPaymentMethod] = useState("razorpay");
//   const [utrId, setUtrId] = useState("");
//   const [screenshot, setScreenshot] = useState(null);
//   const [isSubmitting, setIsSubmitting] = useState(false);
//   const [isPaymentDone, setIsPaymentDone] = useState(false);

//   const {
//     preferredExams,
//     allExams,
//     competitiveExamsList,
//     getMediums,
//     setGetMediums,
//     getMediumOfInstructionsInCompatitiveExam,
//     requestAccess,
//     getCompetitiveExamDetails,
//     getPlans,
//     plansList,
//     accessRequestDetails,
//     submitPaymentProof,
//     cancelPayment,
//     getPaymentSummary,
//     paymentSummary,
//     mail,
//     role,
//     loading,
//     SCHOOL_BASED_EXAMS,
//   } = useHandler();

//   const handleConfirmSelection = async () => {
//     const course = selectedExamForAccess?.title || selectedExamForAccess?.exam;
//     const plans = await getPlans(course);
//     if (plans) {
//       setStep("plans");
//     }
//   };

//   const handleBackToSelection = () => {
//     setStep("selection");
//   };

//   const handlePlanSelect = async (plan) => {
//     setSelectedPlan(plan);
//     const payload = {
//       mail: mail,
//       plan: plan.id,
//       duration: billingCycle.toLowerCase(),
//       class_grade:
//         role?.toUpperCase() === "ASPIRANT" ? null : accessData.classGrade,
//       medium: accessData.medium,
//     };
//     const res = await requestAccess(payload);
//     if (res) {
//       setStep("payment");
//     }
//   };

//   const handleScreenshotSubmit = async () => {
//     if (!utrId || !screenshot) return;
//     setIsSubmitting(true);
//     const success = await submitPaymentProof({
//       request_uuid: accessRequestDetails?.order_id,
//       utr_id: utrId,
//       screenshot: screenshot,
//     });
//     if (success) {
//       await getPaymentSummary(accessRequestDetails?.order_id);
//       setStep("success");
//     }
//     setIsSubmitting(false);
//   };

//   const toggleAccessDropdown = (type) => {
//     setActiveDropdown(activeDropdown === type ? null : type);
//   };

//   const handleSelectAccessValue = (type, value) => {
//     setAccessData({ ...accessData, [type]: value });
//     setActiveDropdown(null);
//   };

//   // const renderSelectionStep = () => (
//   //   <>
//   //     <h3 className="popup_title">
//   //       {role?.toUpperCase() === "ASPIRANT"
//   //         ? "Select Your Medium"
//   //         : "Select Your Class"}
//   //     </h3>
//   //     <p className="popup_desc">
//   //       {role?.toUpperCase() === "ASPIRANT"
//   //         ? "Choose your medium of instruction"
//   //         : "Choose your grade and medium of instruction"}
//   //     </p>

//   //     <section className="input_group_wrapper">
//   //       {role?.toUpperCase() !== "ASPIRANT" && (
//   //         <div className="input_field">
//   //           <label>Class/grade</label>
//   //           <div className="custom_dropdown_container">
//   //             <div
//   //               className={`dropdown_trigger ${activeDropdown === "class" ? "active" : ""}`}
//   //               onClick={() => toggleAccessDropdown("class")}
//   //             >
//   //               <span>{accessData.classGrade}</span>
//   //               <img
//   //                 src={assets.ic_chevron_down}
//   //                 alt="chevron"
//   //                 className={activeDropdown === "class" ? "rotate" : ""}
//   //               />
//   //             </div>
//   //             {activeDropdown === "class" && (
//   //               <div className="dropdown_options_list">
//   //                 {CLASS_OPTIONS.map((opt) => (
//   //                   <div
//   //                     key={opt}
//   //                     className={`dropdown_option_item ${
//   //                       accessData.classGrade === opt ? "selected" : ""
//   //                     }`}
//   //                     onClick={() => handleSelectAccessValue("classGrade", opt)}
//   //                   >
//   //                     {opt}
//   //                   </div>
//   //                 ))}
//   //               </div>
//   //             )}
//   //           </div>
//   //         </div>
//   //       )}

//   //       <div className="input_field">
//   //         <label>Medium</label>
//   //         <div className="custom_dropdown_container">
//   //           <div
//   //             className={`dropdown_trigger ${activeDropdown === "medium" ? "active" : ""}`}
//   //             onClick={() => toggleAccessDropdown("medium")}
//   //           >
//   //             <span>{accessData.medium}</span>
//   //             <img
//   //               src={assets.ic_chevron_down}
//   //               alt="chevron"
//   //               className={activeDropdown === "medium" ? "rotate" : ""}
//   //             />
//   //           </div>
//   //           {activeDropdown === "medium" && (
//   //             <div className="dropdown_options_list">
//   //               {LANGUAGE_OPTIONS.map((opt) => (
//   //                 <div
//   //                   key={opt}
//   //                   className={`dropdown_option_item ${accessData.medium === opt ? "selected" : ""}`}
//   //                   onClick={() => handleSelectAccessValue("medium", opt)}
//   //                 >
//   //                   {opt}
//   //                 </div>
//   //               ))}
//   //             </div>
//   //           )}
//   //         </div>
//   //       </div>
//   //     </section>

//   //     <div className="popup_actions">
//   //       <button
//   //         className="cancel_btn"
//   //         onClick={() => setShowAccessPopup(false)}
//   //       >
//   //         Cancel
//   //       </button>
//   //       <button className="confirm_btn" onClick={handleConfirmSelection}>
//   //         Confirm Selection
//   //       </button>
//   //     </div>
//   //   </>
//   // );

//   const renderSelectionStep = () => {
//     const isSchoolExam = SCHOOL_BASED_EXAMS.includes(
//       selectedExamForAccess?.title,
//     );

//     const isSelectionValid = isSchoolExam
//       ? accessData.classGrade && accessData.medium
//       : accessData.medium;

//     return (
//       <>
//         <h3 className="popup_title">
//           {role?.toUpperCase() === "ASPIRANT"
//             ? "Select Your Medium"
//             : isSchoolExam
//               ? "Select Your Class"
//               : "Select Your Medium"}
//         </h3>

//         <p className="popup_desc">
//           {role?.toUpperCase() === "ASPIRANT"
//             ? "Choose your medium of instruction"
//             : isSchoolExam
//               ? "Choose your grade and medium of instruction"
//               : "Choose your medium of instruction"}
//         </p>

//         <section className="input_group_wrapper">
//           {/* {role?.toUpperCase() !== "ASPIRANT" && isSchoolExam && ( */}
//           {isSchoolExam && (
//             <div className="input_field">
//               <label>Class/grade</label>

//               {/* class dropdown */}
//               <div className="custom_dropdown_container">
//                 <div
//                   className={`dropdown_trigger ${activeDropdown === "class" ? "active" : ""}`}
//                   onClick={() => toggleAccessDropdown("class")}
//                 >
//                   <span>{accessData.classGrade}</span>
//                   <img
//                     src={assets.ic_chevron_down}
//                     alt="chevron"
//                     className={activeDropdown === "class" ? "rotate" : ""}
//                   />
//                 </div>
//                 {activeDropdown === "class" && (
//                   <div className="dropdown_options_list">
//                     {CLASS_OPTIONS.map((opt) => (
//                       <div
//                         key={opt}
//                         className={`dropdown_option_item ${
//                           accessData.classGrade === opt ? "selected" : ""
//                         }`}
//                         onClick={() =>
//                           handleSelectAccessValue("classGrade", opt)
//                         }
//                       >
//                         {opt}
//                       </div>
//                     ))}
//                   </div>
//                 )}
//               </div>
//             </div>
//           )}

//           <div className="input_field">
//             {/* medium dropdown */}

//             <div className="input_field">
//               <label>Medium</label>
//               <div className="custom_dropdown_container">
//                 <div
//                   className={`dropdown_trigger ${activeDropdown === "medium" ? "active" : ""}`}
//                   onClick={() => toggleAccessDropdown("medium")}
//                 >
//                   <span>{accessData.medium}</span>
//                   <img
//                     src={assets.ic_chevron_down}
//                     alt="chevron"
//                     className={activeDropdown === "medium" ? "rotate" : ""}
//                   />
//                 </div>
//                 {activeDropdown === "medium" && (
//                   <div className="dropdown_options_list">
//                     {getMediums?.map((opt) => (
//                       <div
//                         key={opt}
//                         className={`dropdown_option_item ${accessData.medium === opt ? "selected" : ""}`}
//                         onClick={() => handleSelectAccessValue("medium", opt)}
//                       >
//                         {opt}
//                       </div>
//                     ))}
//                   </div>
//                 )}
//               </div>
//             </div>
//           </div>

//           <div className="popup_actions">
//             <button
//               className="cancel_btn"
//               onClick={() => {
//                 setAccessData({
//                   classGrade: "",
//                   medium: "",
//                 });
//                 setShowAccessPopup(false);
//               }}
//             >
//               Cancel
//             </button>
//             <button
//               className={`confirm_btn ${!accessData.medium ? "disabled" : ""}`}
//               onClick={handleConfirmSelection}
//               disabled={!isSelectionValid}
//             >
//               Confirm Selection
//             </button>
//           </div>
//         </section>
//       </>
//     );
//   };

//   const renderPlansStep = () => (
//     <div className="plans_step_container">
//       <div className="stepper_wrapper">
//         <div className="step_item active">
//           <div className="step_num">1</div>
//           <span className="step_label">Choose Plan</span>
//         </div>
//         <div className="step_line"></div>
//         <div className="step_item">
//           <div className="step_num">2</div>
//           <span className="step_label">Complete Payment</span>
//         </div>
//         {/* <div className="step_line"></div>
//         <div className="step_item">
//           <div className="step_num">3</div>
//           <span className="step_label">Share Screenshot + UTR</span>
//         </div> */}
//       </div>

//       <h2 className="plans_main_title">1. Choose Your Plan</h2>
//       <p className="plans_sub_title">
//         Select the plan that's right for you and continue to payment
//       </p>

//       <div className="billing_toggle_container">
//         {["Monthly", "Quarterly", "Yearly"].map((cycle) => (
//           <button
//             key={cycle}
//             className={`toggle_btn ${billingCycle === cycle ? "active" : ""}`}
//             onClick={() => setBillingCycle(cycle)}
//           >
//             {cycle}
//           </button>
//         ))}
//       </div>

//       <div className="plans_grid">
//         {plansList?.map((plan) => {
//           const cycleKey = billingCycle.toLowerCase();
//           const price = plan.pricing?.[cycleKey] || 0;
//           const isFeatured = plan.tier === "pro";

//           return (
//             <div
//               key={plan.id}
//               className={`plan_card ${isFeatured ? "featured" : ""}`}
//             >
//               {isFeatured && <div className="popular_badge">Most Popular</div>}
//               <div className="plan_header">
//                 <h4 className="plan_name">{plan.label}</h4>
//                 <p className="plan_tagline">
//                   {plan.tier === "basic"
//                     ? "For aspirants just getting started"
//                     : plan.tier === "pro"
//                       ? "Best for serious exam preparation"
//                       : "Complete preparation with maximum support"}
//                 </p>
//                 <div className="plan_price">
//                   <span className="currency">₹</span>
//                   <span className="amount">{price.toLocaleString()}</span>
//                 </div>
//                 <p className="plan_validity">Billed {billingCycle}</p>
//               </div>
//               <button
//                 className="plan_select_btn"
//                 onClick={() => handlePlanSelect(plan)}
//               >
//                 Get Started Now
//               </button>
//               <div className="features_list">
//                 <p className="features_header">What's Included:</p>
//                 {(plan.tier === "basic"
//                   ? [
//                       "Live Clasess Access",
//                       "Study Material (PDF)",
//                       "Topic Wise Tests",
//                     ]
//                   : plan.tier === "pro"
//                     ? [
//                         "Everything in Basic Plan",
//                         "Mock Test (All India)",
//                         "Performance Analytics",
//                         "Priority Doubt Support",
//                       ]
//                     : [
//                         "Everything in Pro Plan",
//                         "Personal Mentorship",
//                         "Advanced Mock Analysis",
//                         "Interview Guidance",
//                       ]
//                 ).map((feat, idx) => (
//                   <div key={idx} className="feature_item">
//                     <img src={assets.ic_check_circle} alt="icon" />
//                     <span>{feat}</span>
//                   </div>
//                 ))}
//               </div>
//             </div>
//           );
//         })}

//         {(!plansList || plansList.length === 0) && (
//           <div className="no_plans_message">
//             <p>No plans available for this course at the moment.</p>
//           </div>
//         )}
//       </div>

//       <div className="back_btn_wrapper">
//         <button className="back_btn" onClick={() => setStep("selection")}>
//           &larr; Back to selection
//         </button>
//       </div>
//     </div>
//   );

//   const renderPaymentStep = () => {
//     const cycleKey = billingCycle.toLowerCase();
//     const planPrice = selectedPlan?.pricing?.[cycleKey] || 0;
//     const total = accessRequestDetails?.payment?.amount || planPrice;

//     if (!accessRequestDetails) {
//       return (
//         <div className="payment_loading">
//           <div className="spinner"></div>
//           <p>Preparing your secure payment details...</p>
//         </div>
//       );
//     }

//     return (
//       <div className="payment_step_container">
//         <div className="stepper_wrapper">
//           <div className="step_item active">
//             <div className="step_num">1</div>
//             <span className="step_label">Choose Plan</span>
//           </div>
//           <div className="step_line active"></div>
//           <div className="step_item active">
//             <div className="step_num">2</div>
//             <span className="step_label">Complete Payment</span>
//           </div>
//           {/* <div className="step_line"></div>
//           <div className="step_item">
//             <div className="step_num">3</div>
//             <span className="step_label">Share Screenshot + UTR</span>
//           </div> */}
//         </div>

//         <h2 className="plans_main_title">Complete Your Payment</h2>
//         <p className="plans_sub_title">
//           Securely complete your payment to get instant access to the{" "}
//           {selectedCategory?.title} exam materials.
//         </p>

//         <div className="payment_layout">
//           <div className="payment_main">
//             <div className="amount_card">
//               <div className="amount_info">
//                 <span className="label">Total Amount to Pay</span>
//                 <h3 className="total_val">₹{total.toLocaleString()}</h3>
//               </div>
//               <div className="order_id_badge">
//                 Order ID: {accessRequestDetails?.order_id}
//               </div>
//             </div>

//             {/* <p className="method_title">Select Payment Method</p> */}
//             <div className="methods_card">
//               <div className="method_tabs">
//                 {/* <button
//                   className={`tab_btn ${paymentMethod === "bank" ? "active" : ""}`}
//                   onClick={() => setPaymentMethod("bank")}
//                 >
//                   <img src={assets.ic_bank} alt="bank" /> Bank Transfer
//                 </button> */}
//                 {/* <button
//                   className={`tab_btn ${paymentMethod === "qr" ? "active" : ""}`}
//                   onClick={() => setPaymentMethod("qr")}
//                 >
//                   <img src={assets.ic_aitv} alt="qr" /> QR / UPI
//                 </button> */}
//                 <button
//                   className={`tab_btn ${paymentMethod === "razorpay" ? "active" : ""}`}
//                   onClick={() => setPaymentMethod("razorpay")}
//                 >
//                   {/* <img src={assets.ic_magic_logo} alt="razorpay" /> */}
//                   <img src={assets.ic_payicon} alt="ic_payicon" />
//                   Razorpay
//                 </button>
//               </div>

//               <div className="method_content">
//                 {paymentMethod === "bank" ? (
//                   <div className="bank_details_view">
//                     <div className="bank_header">
//                       <img src={assets.ic_bank} alt="icon" />
//                       <div>
//                         <h4>Pay via Bank Transfer</h4>
//                         <p>Transfer the amount to the following bank account</p>
//                       </div>
//                     </div>
//                     <div className="details_grid">
//                       {[
//                         {
//                           label: "Bank Name",
//                           value: accessRequestDetails?.payment?.bank_name,
//                         },
//                         {
//                           label: "Account Number",
//                           value: accessRequestDetails?.payment?.account_no,
//                         },
//                         {
//                           label: "Beneficiary Name",
//                           value:
//                             accessRequestDetails?.payment?.account_holder_name,
//                         },
//                         {
//                           label: "Account Type",
//                           value:
//                             accessRequestDetails?.payment?.account_type ||
//                             "Current Account",
//                         },
//                         {
//                           label: "Branch",
//                           value: accessRequestDetails?.payment?.branch_name,
//                         },
//                         {
//                           label: "IFSC Code",
//                           value: accessRequestDetails?.payment?.ifsc,
//                         },
//                       ].map((item, i) => (
//                         <div key={i} className="detail_item">
//                           <span className="det_label">{item.label}</span>
//                           <span className="det_val">{item.value}</span>
//                         </div>
//                       ))}
//                     </div>
//                     <div className="alert_info">
//                       <img src={assets.ic_info} alt="info" />
//                       <p>
//                         Please ensure the transfer amount matches the total due
//                         exactly for automated verification.
//                       </p>
//                     </div>
//                   </div>
//                 ) : paymentMethod === "qr" ? (
//                   <div className="qr_details_view">
//                     <div className="qr_header">
//                       <img src={assets.ic_aitv} alt="icon" />
//                       <div>
//                         <h4>Pay via QR / UPI</h4>
//                         <p>Scan the QR code using any UPI app</p>
//                       </div>
//                     </div>
//                     <div className="qr_container">
//                       <img
//                         src={
//                           accessRequestDetails?.payment?.qr_image_url ||
//                           selectedPlan?.qr_url ||
//                           assets.sample_qr
//                         }
//                         alt="QR Code"
//                         className="main_qr"
//                       />
//                     </div>
//                     <p className="upi_divider">or pay using UPI ID</p>
//                     <div className="upi_id_copy">
//                       <span>{accessRequestDetails?.payment?.upi_id}</span>
//                       <button>
//                         <img src={assets.ic_copy} alt="copy" />
//                       </button>
//                     </div>
//                   </div>
//                 ) : (
//                   <div className="razorpay_details_view">
//                     <div className="razorpay_header">
//                       <img src={assets.ic_magic_logo} alt="icon" />
//                       <div>
//                         <h4>Pay with Razorpay</h4>
//                         <p>Fast, secure and automated payment gateway</p>
//                       </div>
//                     </div>
//                     <div className="gateway_preview">
//                       <div className="gateway_card">
//                         <img
//                           src={assets.ic_magic_logo}
//                           alt="razorpay"
//                           className="gateway_logo"
//                         />
//                         <div className="gateway_info">
//                           <p className="merchant_name">Rovian EdTech</p>
//                           <p className="pay_amount">
//                             ₹{total.toLocaleString()}
//                           </p>
//                         </div>
//                       </div>
//                       <a
//                         href={accessRequestDetails?.payment?.razor_pay_url?.url}
//                         target="_blank"
//                         rel="noopener noreferrer"
//                         onClick={() => setIsPaymentDone(true)}
//                       >
//                         <button className="razorpay_pay_btn">
//                           Pay Now with Razorpay
//                         </button>
//                       </a>
//                       <p className="security_note">
//                         Protected by 128-bit SSL encryption
//                       </p>
//                     </div>
//                   </div>
//                 )}
//               </div>
//             </div>
//           </div>

//           <div className="payment_sidebar">
//             <div className="order_summary_card">
//               <h4 className="summary_title">Order Summary</h4>
//               <div className="summary_list">
//                 <div className="summary_item">
//                   <div>
//                     <p className="item_name">
//                       {accessRequestDetails?.plan || selectedPlan?.label}
//                     </p>
//                     <p className="item_sub">
//                       {accessRequestDetails?.payment?.duration || billingCycle}{" "}
//                       Plan
//                     </p>
//                   </div>
//                   <p className="item_price">
//                     ₹
//                     {(
//                       accessRequestDetails?.payment?.amount || planPrice
//                     ).toLocaleString()}
//                   </p>
//                 </div>
//               </div>
//               <div className="total_row">
//                 <span>Amount to Pay</span>
//                 <div className="total_final">
//                   <h3>₹{total.toLocaleString()}</h3>
//                   <p>Includes all applicable taxes</p>
//                 </div>
//               </div>
//               <button
//                 className={`confirm_payment_btn ${isPaymentDone ? "disabled" : ""}`}
//                 onClick={() => setStep("screenshot")}
//                 disabled={!isPaymentDone}
//               >
//                 Confirm Payment &rarr;
//               </button>
//               {/* <button
//                 className="cancel_payment_btn"
//                 onClick={async () => {
//                   if (accessRequestDetails?.order_id) {
//                     await cancelPayment(accessRequestDetails.order_id);
//                   }
//                   setStep("plans");
//                 }}
//               >
//                 Cancel Payment
//               </button> */}
//             </div>
//             <div className="order_summary_card note">
//               <h4 className="summary_title">Guidelines</h4>
//               <div className="summary_list">
//                 <ul>
//                   {accessRequestDetails?.payment?.note?.map((item, index) => (
//                     <li key={index}>{item}</li>
//                   ))}
//                 </ul>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     );
//   };

//   const renderScreenshotStep = () => {
//     return (
//       <div className="screenshot_step_container">
//         <div className="stepper_wrapper">
//           <div className="step_item active">
//             <div className="step_num">
//               <img
//                 src={assets.ic_tick_white}
//                 alt="1"
//                 style={{ width: "16px" }}
//               />
//             </div>
//             <span className="step_label">Choose Plan</span>
//           </div>
//           <div className="step_line active"></div>
//           <div className="step_item active">
//             <div className="step_num">
//               <img
//                 src={assets.ic_tick_white}
//                 alt="2"
//                 style={{ width: "16px" }}
//               />
//             </div>
//             <span className="step_label">Complete Payment</span>
//           </div>
//           <div className="step_line active"></div>
//           <div className="step_item active">
//             <div className="step_num">3</div>
//             <span className="step_label">Share Screenshot + UTR</span>
//           </div>
//         </div>

//         <h2 className="plans_main_title">3. Share Screenshot + UTR</h2>
//         <p className="plans_sub_title">
//           Please share your payment screenshot and enter UTR / Reference number
//           to verify your payment.
//         </p>

//         <div className="payment_summary_card">
//           <div className="summary_header">
//             <div className="title">
//               <img src={assets.ic_bank} alt="summary" />
//               <span>Payment Summary</span>
//             </div>
//             <div className="method_badge">{paymentMethod.toUpperCase()}</div>
//           </div>

//           <div className="summary_grid">
//             <div className="summ_item">
//               <span className="label">Selected Plan</span>
//               <span className="val primary">
//                 {accessRequestDetails?.plan || selectedPlan?.label}
//               </span>
//             </div>
//             <div className="summ_item">
//               <span className="label">Order ID</span>
//               <span className="val">{accessRequestDetails?.order_id}</span>
//             </div>
//             <div className="summ_item">
//               <span className="label">Date</span>
//               <span className="val">{new Date().toLocaleDateString()}</span>
//             </div>
//             <div className="summ_item">
//               <span className="label">Time</span>
//               <span className="val">
//                 {new Date().toLocaleTimeString([], {
//                   hour: "2-digit",
//                   minute: "2-digit",
//                 })}
//               </span>
//             </div>
//           </div>

//           <div className="summary_footer">
//             <span>Total Amount Paid</span>
//             <span className="amount">
//               INR {accessRequestDetails?.payment?.amount || 0}
//             </span>
//           </div>
//         </div>

//         <div className="verification_details">
//           <div className="verify_step">
//             <div className="step_num">1</div>
//             <div className="step_info">
//               <h4>Upload Payment Screenshot</h4>
//               <p>Upload a clear screenshot of the successful transaction.</p>
//             </div>
//           </div>

//           <div
//             className={`upload_area ${screenshot ? "has_file" : ""}`}
//             onClick={() =>
//               document.getElementById("screenshot_upload_role").click()
//             }
//           >
//             <input
//               id="screenshot_upload_role"
//               type="file"
//               hidden
//               onChange={(e) => setScreenshot(e.target.files[0])}
//               accept="image/*"
//             />
//             <img
//               src={assets.ic_active_files}
//               alt="upload"
//               className="upload_icon"
//             />
//             {screenshot ? (
//               <div className="file_info">
//                 <p className="file_name">{screenshot.name}</p>
//               </div>
//             ) : (
//               <>
//                 <p className="main_text">Tap or drag screenshot here</p>
//                 <p className="sub_text">JPG, PNG, WEBP up to 5MB</p>
//               </>
//             )}
//           </div>

//           <div className="verify_step">
//             <div className="step_num">2</div>
//             <div className="step_info">
//               <h4>Enter UTR / Reference Number</h4>
//               <p>Enter 12 digit number from your payment receipt</p>
//             </div>
//           </div>
//           <div className="utr_input_wrapper">
//             <label>UTR / Reference Number *</label>
//             <div className="input_container">
//               <span className="hash">#</span>
//               <input
//                 type="text"
//                 placeholder="e.g. 321456789012"
//                 value={utrId}
//                 onChange={(e) => {
//                   const val = e.target.value.replace(/\D/g, "");
//                   if (val.length <= 20) setUtrId(val);
//                 }}
//               />
//             </div>
//           </div>

//           <button
//             className={`submit_verify_btn ${isSubmitting || utrId.length < 12 || !screenshot ? "disabled" : ""}`}
//             onClick={handleScreenshotSubmit}
//             disabled={isSubmitting || utrId.length < 12 || !screenshot}
//           >
//             {isSubmitting ? "Submitting..." : "Submit for Verification"}
//           </button>

//           <p className="review_note">
//             Reviewed within 2–4 hours. You will receive an email update.
//           </p>
//         </div>
//       </div>
//     );
//   };

//   const renderSuccessStep = () => {
//     return (
//       <div className="success_step_container">
//         <div className="success_header">
//           <div className="success_icon_wrapper">
//             <img
//               src={assets.ic_tick_white}
//               alt="success"
//               className="success_tick"
//             />
//           </div>
//           <h2>Payment Details Submitted Successfully!</h2>
//           <p>
//             Our verification team is now reviewing your transaction.
//             <br />
//             Expect access to your course within <strong>3 hours</strong>.
//           </p>
//         </div>

//         <div className="success_summary_card">
//           <div className="summary_grid">
//             <div className="summ_item">
//               <span className="label">PLAN</span>
//               <span className="val">
//                 {paymentSummary?.plan ||
//                   accessRequestDetails?.plan ||
//                   selectedPlan?.label}
//               </span>
//             </div>
//             <div className="summ_item">
//               <span className="label">AMOUNT</span>
//               <span className="val amount">
//                 ₹
//                 {(
//                   paymentSummary?.amount ||
//                   accessRequestDetails?.payment?.amount ||
//                   0
//                 ).toLocaleString()}
//               </span>
//             </div>
//             <div className="summ_item">
//               <span className="label">METHOD</span>
//               <span className="val">
//                 {paymentMethod === "bank" ? "Bank Transfer" : "QR / UPI"}
//               </span>
//             </div>
//             <div className="summ_item">
//               <span className="label">DATE</span>
//               <span className="val">
//                 {new Date().toLocaleDateString("en-US", {
//                   month: "short",
//                   day: "numeric",
//                   year: "numeric",
//                 })}
//               </span>
//             </div>
//             <div className="summ_item">
//               <span className="label">UTR / TRANSACTION ID</span>
//               <div className="val_copy">
//                 <span>{paymentSummary?.utr_id || utrId}</span>
//                 <img
//                   src={assets.ic_copy}
//                   alt="copy"
//                   className="copy_icon"
//                   onClick={() =>
//                     navigator.clipboard.writeText(
//                       paymentSummary?.utr_id || utrId,
//                     )
//                   }
//                 />
//               </div>
//             </div>
//           </div>
//         </div>

//         <div className="next_steps_section">
//           <h3>What happens next?</h3>
//           <div className="steps_grid">
//             <div className="step_card">
//               <div className="icon_wrapper verify">
//                 <img src={assets.ic_time} alt="verify" />
//               </div>
//               <h4>Verification</h4>
//               <p>
//                 Our finance team cross-checks the UTR with our bank records.
//               </p>
//             </div>
//             <div className="step_card">
//               <div className="icon_wrapper email">
//                 <img src={assets.ic_mail_box} alt="email" />
//               </div>
//               <h4>Email</h4>
//               <p>
//                 A confirmation email with login credentials will be sent to you.
//               </p>
//             </div>
//             <div className="step_card">
//               <div className="icon_wrapper access">
//                 <img src={assets.ic_join_rocket} alt="access" />
//               </div>
//               <h4>Access</h4>
//               <p>Unlock the comprehensive curriculum and student community.</p>
//             </div>
//           </div>
//         </div>

//         <div className="success_actions">
//           <button
//             className="btn_dashboard"
//             onClick={() => {
//               setShowAccessPopup(false);
//               setStep("selection");
//               setUtrId("");
//               setScreenshot(null);
//               window.location.reload();
//             }}
//           >
//             &larr; Go to Dashboard
//           </button>
//         </div>
//       </div>
//     );
//   };

//   // const examStatusMap =
//   //   competitiveExamsList?.reduce((acc, item) => {
//   //     if (item.exam) {
//   //       acc[item.exam.toUpperCase()] = item.status;
//   //     }
//   //     return acc;
//   //   }, {}) || {};

//   const examStatusMap =
//     competitiveExamsList?.all?.reduce((acc, item) => {
//       acc[item.exam] = item.status;
//       return acc;
//     }, {}) || {};

//   const toggleDropdown = () => setIsOpen((prev) => !prev);

//   const onSelectCategory = (item) => {
//     setSelectedCategory(item);
//     setIsOpen(false);
//   };

//   const GridIcon = ({ active }) => (
//     <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
//       <rect
//         x="3"
//         y="3"
//         width="6"
//         height="6"
//         rx="1.5"
//         fill={active ? "#092E5E" : "#B9B9B9"}
//       />
//       <rect
//         x="11"
//         y="3"
//         width="6"
//         height="6"
//         rx="1.5"
//         fill={active ? "#092E5E" : "#B9B9B9"}
//       />
//       <rect
//         x="3"
//         y="11"
//         width="6"
//         height="6"
//         rx="1.5"
//         fill={active ? "#092E5E" : "#B9B9B9"}
//       />
//       <rect
//         x="11"
//         y="11"
//         width="6"
//         height="6"
//         rx="1.5"
//         fill={active ? "#092E5E" : "#B9B9B9"}
//       />
//     </svg>
//   );

//   const ListIcon = ({ active }) => (
//     <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
//       <circle cx="4" cy="5" r="1.5" fill={active ? "#092E5E" : "#B9B9B9"} />
//       <rect
//         x="7"
//         y="4"
//         width="10"
//         height="2"
//         rx="1"
//         fill={active ? "#092E5E" : "#B9B9B9"}
//       />
//       <circle cx="4" cy="10" r="1.5" fill={active ? "#092E5E" : "#B9B9B9"} />
//       <rect
//         x="7"
//         y="9"
//         width="10"
//         height="2"
//         rx="1"
//         fill={active ? "#092E5E" : "#B9B9B9"}
//       />
//       <circle cx="4" cy="15" r="1.5" fill={active ? "#092E5E" : "#B9B9B9"} />
//       <rect
//         x="7"
//         y="14"
//         width="10"
//         height="2"
//         rx="1"
//         fill={active ? "#092E5E" : "#B9B9B9"}
//       />
//     </svg>
//   );

//   const renderExamCard = (item, index) => {
//     const { icon, title, description, courseName, bgColor, brColor, color } =
//       item || {};
//     const status = examStatusMap[title?.toUpperCase()];

//     const handleOpenPopup = async () => {
//       if (!status || status === "REQUEST_ACCESS") {
//         setSelectedExamForAccess(item);

//         if (item.title === "Communicative English") {
//           // Required because setState is async
//           const plans = await getPlans(item.title);

//           if (plans) {
//             setStep("plans");
//             setShowAccessPopup(true);
//           }

//           return;
//         }

//         await getMediumOfInstructionsInCompatitiveExam(item);

//         setAccessData({ classGrade: "Class 8", medium: "English" });
//         setStep("selection");
//         setShowAccessPopup(true);
//       }
//     };

//     if (viewMode === "grid") {
//       return (
//         <section key={index} className="competitive_exam_card_wrapper">
//           <section className="card_icon_container">
//             <img src={icon} alt={title} />
//           </section>
//           <h5>{title}</h5>
//           <p>{description}</p>
//           <section
//             className="competitive_course_wrapper"
//             style={{
//               background: bgColor,
//               border: `1px solid ${brColor}`,
//               color: color,
//             }}
//           >
//             <h5>{courseName}</h5>
//           </section>
//           <section
//             className={`start_chart_wrapper ${!status || status === "REQUEST_ACCESS" ? "" : "waiting_approval"}`}
//             onClick={handleOpenPopup}
//           >
//             {status === "APPROVED" && <h5 className="start_text">Approved</h5>}
//             {status === "PENDING" && (
//               <Fragment>
//                 <img src={assets.ic_time} alt="ic_time" />
//                 <h5 className="start_text">Waiting for approval</h5>
//               </Fragment>
//             )}
//             {(!status || status === "REQUEST_ACCESS") && (
//               <h5 className="start_text">Request for access</h5>
//             )}
//           </section>
//         </section>
//       );
//     }

//     return (
//       <section key={index} className="competitive_exam_card_wrapper list_view">
//         <section className="card_left_content">
//           <img src={icon} alt={title} className="exam_icon" />
//           <section className="exam_info">
//             <h5>{title}</h5>
//             <p>{description}</p>
//           </section>
//           <section
//             className="competitive_course_wrapper"
//             style={{
//               background: bgColor,
//               border: `1px solid ${brColor}`,
//               color: color,
//             }}
//           >
//             <h5>{courseName}</h5>
//           </section>
//         </section>
//         <section
//           className={`start_chart_wrapper ${!status || status === "REQUEST_ACCESS" ? "" : "waiting_approval"}`}
//           onClick={handleOpenPopup}
//         >
//           {status === "APPROVED" && <h5 className="start_text">Approved</h5>}
//           {status === "PENDING" && (
//             <Fragment>
//               <img src={assets.ic_time} alt="ic_time" />
//               <h5 className="start_text">Waiting for approval</h5>
//             </Fragment>
//           )}
//           {(!status || status === "REQUEST_ACCESS") && (
//             <h5 className="start_text">Request for access</h5>
//           )}
//         </section>
//       </section>
//     );
//   };

//   return (
//     <section className="competitive_main_wrapper">
//       <section className="competitive_header_wrapper">
//         <section className="competitive_heading_content">
//           <h4 className="competitive_heading_text">Competitive Exams</h4>
//           <h6 className="competitive_heading_desc">
//             Prepare for India's top entrance and government exams with AI
//             guidance
//           </h6>
//         </section>
//         <section className="competitive_controls">
//           <section className="competitive_dropdown_container">
//             {/* <section className="dropdown_cat_wrapper" onClick={toggleDropdown}>
//               <h5 className="cat_lable_text">{selectedCategory?.label}</h5>
//               <img
//                 src={assets.ic_chevron_down}
//                 alt="ic_chevron_down"
//                 className={isOpen ? "rotate" : ""}
//               />
//             </section>
//             {isOpen && (
//               <section className="dropdown_list">
//                 {CATEGORY_LIST?.map((item) => (
//                   <section
//                     key={item.id}
//                     className="dropdown_item"
//                     onClick={() => onSelectCategory(item)}
//                   >
//                     {item.label}
//                   </section>
//                 ))}
//               </section>
//             )} */}
//           </section>
//           <section className="view_toggle_container">
//             <section
//               className={`view_btn ${viewMode === "grid" ? "view_active" : ""}`}
//               onClick={() => setViewMode("grid")}
//             >
//               <GridIcon active={viewMode === "grid"} />
//             </section>
//             <section
//               className={`view_btn ${viewMode === "list" ? "view_active" : ""}`}
//               onClick={() => setViewMode("list")}
//             >
//               <ListIcon active={viewMode === "list"} />
//             </section>
//           </section>
//         </section>
//       </section>
//       {/* <section className={`competitive_exam_card_container ${viewMode}`}>
//         {COMPETITIVE_EXAM_STATIC_DATA?.map(renderExamCard)}
//       </section> */}

//       {/* Preferred Exams */}
//       {!!preferredExams?.length && (
//         <section className="competitive_section_wrapper">
//           <h4 className="section_heading">Preferred Exams</h4>

//           <section className={`competitive_exam_card_container ${viewMode}`}>
//             {preferredExams?.map(renderExamCard)}
//           </section>
//         </section>
//       )}

//       {/* All Exams */}
//       {!!allExams?.length && (
//         <section className="competitive_all_section_wrapper">
//           <h4 className="section_heading">All Exams</h4>

//           <section className={`competitive_exam_card_container ${viewMode}`}>
//             {allExams?.map(renderExamCard)}
//           </section>
//         </section>
//       )}

//       <Popup
//         isOpen={showAccessPopup}
//         onClose={() => setShowAccessPopup(false)}
//         wrapperClass={
//           step === "selection" ? "access_request_modal" : "plans_modal_full"
//         }
//         hideClose={true}
//         isLoading={loading}
//       >
//         <section className="access_request_popup_content">
//           {step === "selection"
//             ? renderSelectionStep()
//             : step === "plans"
//               ? renderPlansStep()
//               : step === "payment"
//                 ? renderPaymentStep()
//                 : step === "success"
//                   ? renderSuccessStep()
//                   : renderScreenshotStep()}
//         </section>
//       </Popup>
//     </section>
//   );
// };


import { CompetitiveExam as BankCompetitiveExam } from "../../components/competitive-exam";
import "./styles.sass";

export const CompetitiveExam = () => {
  return (
    <>
      <BankCompetitiveExam />
    </>
  );
};